import { cn } from '@/utils/cn';

interface CardContainerProps {
  hasBlueBorder?: boolean;
  children: React.ReactNode;
}

const CardContainer: React.FC<CardContainerProps> = ({ hasBlueBorder = false, children }: CardContainerProps) => {
  return (
    <div
      className={cn(
        'flex flex-1 h-[calc(max(750px,100vh-263px))] rounded-2xl',
        hasBlueBorder ? 'border-2 border-blue-100' : 'border border-border-primary bg-surface-tertiary',
      )}
    >
      {hasBlueBorder ? (
        <div className='flex flex-1 rounded-2xl overflow-hidden'>
          <div className='flex flex-1 flex-col bg-surface-tertiary'>{children}</div>
        </div>
      ) : (
        <div className='flex flex-1 flex-col'>{children}</div>
      )}
    </div>
  );
};

export default CardContainer;
